<template>
	<div class='container'>
		<div class="banner">
			<img src="../assets/images/competition/banner.jpg" width='100%' alt="">
		</div>
		<div class='game'>
			猫咪是孤独时的陪伴，是快乐的源泉<br>
			也是我们重要的家人<br>
			我们用心找寻世间猫咪好物<br>
			想将更好的爱都给它们<br>
			<br>
			<span class="font-medium">MollyBox</span>魔力猫盒<br>
			向广大爱猫设计师征集创意猫咪产品-“神秘<span class="font-medium">X</span>”<br>
			给猫咪们带来与众不同的快乐喵生<br>
			打开铲屎官们全新的养猫生活方式<br>
			<br>
			有一颗爱猫之心，也许世间万物<br>
			在你笔下，皆可为猫所用<br>
		</div>
		<div class="introduce wrap-width">
			<img src="../assets/images/competition/introduce-cat.png" alt="" width="6%" class='introduce-cat'> 
			<div class="introduction">
				<game-title>产品介绍</game-title>
				<div class="detail">
					<span>
						<span class='special'><span class="font-medium">MollyBox</span>魔力猫盒</span>
						是国内首家订阅制宠物电商品牌,<br>
						以提供订阅服务的方式每月向顾客邮寄猫盒，<br>
						解决猫咪日常所需，打开全新猫咪生活方式。<br>
					</span>
				</div>
				<div class="detail">
					<span>
						在<span class="special"><span class="font-medium">MollyBox</span>魔力猫盒</span>中，每个月都会有固定搭配：<br>
						<span class="special">猫粮+罐头+零食+玩具+“神秘<span class="font-medium">X</span>”</span>。<br>
						每期盒子都会需要一个 <span class="special">“神秘<span class="font-medium">X</span>”，</span> <br>
						这是<span class="font-medium">MollyBox</span>魔力猫盒独家定制送给订阅用户和他们的喵星人的礼物。
					</span>
				</div>
				<div class="overview">过往“神秘<span class="font-medium">X</span>”一览:</div>
				<div class="one-row">
					<div class="pictures">
						<div class="pic-item">
							<img src="../assets/images/competition/calendar.png" alt="" width="100%">					
							<div class='item-desc'>小台历</div>
						</div>
						<div class="pic-item">
							<img src="../assets/images/competition/bag.png" width="100%" alt="">
							<div class='item-desc'>帆布包</div>
						</div>
						<div class="pic-item">
							<img src="../assets/images/competition/cup.png" width="100%" alt="">
							<div class='item-desc'>猫爪杯</div>
						</div>
					</div>
					<div class='usage'>*铲屎官专用</div>
				</div>
				<div class="one-row">
					<div class="pictures">
						<div class="pic-item">
							<img src="../assets/images/competition/toys.png" width="100%"  alt="">
							<div class='item-desc'>玩具</div>
						</div>
						<div class="pic-item">
							<img src="../assets/images/competition/cloak.png" width="100%"  alt="">
							<div class='item-desc'>小斗篷</div>
						</div>
						<div class="pic-item">
							<img src="../assets/images/competition/headgear.png" width="100%" alt="">
							<div class='item-desc'>兔头套</div>
						</div>
					</div>
					<div class='usage'>*猫咪专用</div>
				</div>
			</div>
		</div>
		<vertical-bar></vertical-bar>
		<div class="wrap-width">
			<game-title>时间安排</game-title>
			<div class="procedure">
				<div class='procedure-item'>
					<div><span class="font-medium">6</span>月<span class="font-medium">1</span>日至<span class="font-medium">7</span>月<span class="font-medium">31</span>日</div>
					<div class="step">征集</div>
				</div>
				<div class="arrow">
					<img src="../assets/images/competition/arrow.jpg" width="100%" alt="">
				</div>				
				<div class='procedure-item'>
					<div><span class="font-medium">8</span>月<span class="font-medium">1</span>日至<span class="font-medium">8</span>月<span class="font-medium">20</span>日</div>
					<div class="step">评选</div>
				</div>
				<div class="arrow">
					<img src="../assets/images/competition/arrow.jpg" width="100%" alt="">
				</div>
				
				<div class='procedure-item'>
					<div><span class="font-medium">8</span>月<span class="font-medium">21</span>日至<span class="font-medium">8</span>月<span class="font-medium">25</span>日</div>
					<div class="step">公示</div>
				</div>
			</div>
		</div>
		<vertical-bar></vertical-bar>
		<div class="prize wrap-width">
			<img src="../assets/images/competition/prize-cat.png" width="11.5%" alt="" class='prize-cat'> 
			<game-title>奖品设置</game-title>
			<div class="pictures">
				<div class="pic-item">
					<img src="../assets/images/competition/prize1.png" width="100%" alt="">	
					<div class='quantity center'>(<span class="font-medium">2</span>名)</div>
				</div>
				<div class="pic-item">
					<img src="../assets/images/competition/prize2.png"  width="100%" class="best" alt="">	
					<div class='quantity center'>(<span class="font-medium">1</span>名)</div>
				</div>
				<div class="pic-item">
					<img src="../assets/images/competition/prize3.png"   width="100%" alt="">	
					<div class='quantity center'>(<span class="font-medium">3</span>名)</div>
				</div>
			</div>
		</div>
		<vertical-bar></vertical-bar>
		<div class="criterion wrap-width">
			<img src="../assets/images/competition/criterion-cat.png" width="9.2%" alt="" class='criterion-cat'> 
			<game-title>评选标准</game-title>
			<div class="clearfix">
				<div class="pic-item">
					<img src="../assets/images/competition/sheji.png" alt="">	
					<div class='quantity center one-line'>构图合理，层次分明，主题 <br>突出，色彩协调，视觉冲击力强</div>
				</div>
				<div class="pic-item">
					<img src="../assets/images/competition/chuangyi.png" alt="">	
					<div class='quantity center one-line'>立意新颖，构思巧妙， <br>视角独特，充分发挥想象力</div>
				</div>
				<div class="pic-item">
					<img src="../assets/images/competition/shiyong.png" alt="">	
					<div class='quantity center one-line'>形象可延展，应用性强<br>最大满足猫咪需求</div>
				</div>
				<div class="pic-item">
					<img src="../assets/images/competition/chuanbo.png" alt="">	
					<div class='quantity center'>作品易于传播，可引起潜在<br>客户群体，对品牌产生共鸣</div>
				</div>
			</div>
		</div>
		<vertical-bar></vertical-bar>	
		<div class="footer-wrap">
		<div class="explain introduce wrap-width">
			<img src="../assets/images/competition/explain-cat.png" width="9%" alt="" class='explain-cat'> 
			<game-title>参赛说明</game-title>
			<h3 class='explain-title'> 设计说明</h3>
			<p>
				<ol>
					<li>产品设计可以是猫咪用品（如逗猫棒），也可以是猫形象周边（如猫爪杯），作品表现手法不限。</li>
					<li>产品设计需富有创意与传播度，让猫咪爱玩、铲屎官想晒，是最合适的。</li>
					<li>设计使用软件不限，作品提交需同时附上作品创作思路或设计说明简述。</li>
					<li>参赛作品需保留<span class="font-medium">300dpi</span>分辨率可用于媒体传播及印刷生产的位图源文件或矢量文件。</li>
					<li>作品需保证完整性且符合国家相关法律法规的要求，完全原创，无剽窃行为，无在先使用行为，涉及猫形象，可采用<span class="font-medium">MollyBox</span>
					魔力猫盒自有猫咪素材，或者自行创作。</li>
				</ol>
			</p>
			<h3 class='explain-title'> 参赛方式及要求</h3>
			<p>
				<ol>
					<li>设计类作品请提供矢量源文件，分辨率不低于<span class="font-medium">300dpi</span>，发至邮箱<span class="font-medium">design@xolo.vip</span>，并附上简要创作思路说明或设计说明简述。</li>
					<li>手工/绘画类作品请提供高清图片，发至邮箱<span class="font-medium">design@xolo.vip</span> ，并附上简要创作思路说明或设计说明简述。你的创作将有机会送到全国的铲屎官手中，成为万千小猫咪的心头爱！<br>
					最终获奖名单将于<span class="font-medium">8</span>月中下旬在<span class="font-medium">MollyBox</span>魔力猫盒微信公众号、微博、亚宠展现场上公布，敬请关注！
					</li>
				</ol>
			</p>
			<h3 class='explain-title'> 获奖通知</h3>
			<p>
				<ol>
					<li>获奖通知将在最终结果公示后<span class="font-medium">5</span>个工作日内通过邮件方式发送至获奖设计师参赛报名时预留的邮箱地址，请确认提供真实有效的联系方式。</li>
					<li>获奖设计师在活动结束后请注意查收邮件，并根据邮件提示内容，配合完成作品收集、相应版权协议签署及奖金奖品发放等工作。</li>
					<li>若参赛者在限定时间内对获奖通知未做回应，则视为放弃奖项，由其他获奖者取代。</li>	
					<li>获奖奖金将在比赛结束后安排发放，所有奖金均为税前金额，由奖金发放方代扣代缴，同一获奖者可获得多个奖项，但需对所得的全部奖项金额进行合并计税并代扣代缴。</li>
				</ol>
			</p>
			<h3 class='explain-title'> 相关权益</h3>
			<p>
				<ol>
					<li>【最佳方案奖】、【优秀方案奖】和【入围方案奖】（共<span class="font-medium">6</span>组）的完整版权将转让至主办方公司（或其指定的公司），作者需协助签署《著作权转让协议》。主办方享有对相应设计方案进行再设计、生产、销售、展示、出版等全部权益，作者不得将此权利再次授权任何其他个人或机构。作者保留对其作品的永久署名权。</li>
					<li>若主办方需对获奖作品进行进一步完善或开发、设计周边产品，获奖作者需协助配合。</li>
					<li>未获奖作品版权归原作者所有，主办方不得以任何形式使用或外泄未获得授权作品的源文件。</li>	
					<li>主办单位及承办单位拥有对全部参赛作品进行展示、报道、宣传及用于市场活动的权利，作者保留对其作品的署名权。主办方如需对获奖作品外的参赛作品进行开发、生产、销售等商业用途，需取得作者书面许可，并向作者支付相应设计费用。</li>
					<li>作品一经提交，将视为参赛作者同意并遵守比赛相关规定，若作品在商业使用中其著作权存在争议，主办单位不承担因作品侵犯他人（或单位）的权利而产生的法律责任，由提供作品的参赛者承担全部法律责任。</li>
					<li>如果获奖作者放弃履行相关版权转让或授权义务，则视为主动放弃相应奖项。</li>
					<li>主办方对本活动保留最终解释权。</li>
				</ol>
			</p>
		</div>
		<vertical-bar></vertical-bar>
		
			<div class="prize wrap-width">
				<game-title>联系我们</game-title>
				<div class='contact center'>若需查看设计大赛最新进程或对本次猫咪用品创意设计大赛有任何疑问，可通过以下方式联系我们：</div>
				<div class='contactUs'>
					<div class='way'>
						<div class="wechat">
							<img src="../assets/images/competition/qrcode.png" alt="">
						</div>					
						<span class="ourwechat">
							<span class="font-medium">MollyBox</span>魔力猫盒官方微信
						</span>
					</div>
					<div class='oneline'></div>
					<div class="way">
							<a href="http://weibo.com/mollybox" class='microblog' target="_blank">
								<img src="../assets/images/competition/microblog.png" alt="">
								<span><span class="font-medium">MollyBox</span>魔力猫盒官方微博</span>
							</a>
					</div>
				</div>
				<a href="javascript:;" @click="download" download class="download">点击下载参赛资料 >></a>
			</div>
		</div>
	</div>
</template>
<script>
import gameTitle from '../components/title'
import verticalBar from '../components/verticalBar'
export default {
	methods:{
		download(){
			window.location.href='./万物皆可猫-猫咪产品创意设计大赛.zip'
		}
	},
	components:{
		gameTitle,
		verticalBar
	}
}
</script>
<style scoped lang="less">
	.container{
		background-color: #ed5959;
		margin-top: 80px;
		
	}
	.game{
		width: 507px;
		margin: -67px auto 0;
		font-size: 16px;
		line-height:30px;
		text-align:center;
		letter-spacing: 2px;
		color: #fff;
		margin-top:-85%;		
	}
	.introduce{
		margin-top: 50px !important;
		background: linear-gradient(90deg, rgba(242, 224, 226, 0.5) 10%, transparent 0), linear-gradient(rgba(242, 224, 226, 0.5) 10%, transparent 0);
		background-size: 18px 18px;
		position: relative;
		.introduction{
			display: flex;
			justify-content: center;
			align-items: center;
			flex-direction: column;
			span{
				color: #333;
			}	
			.special{
				color:#b2261e;
				font-weight:700
			}
		}
		.introduce-cat{
			position: absolute;
			right: 1%;
    	top: -4.5%;
		}
	}

	.detail{
		text-align:center;
		font-size:18px;
		line-height:31px;
		color:#333;
	}
	.detail:nth-child(3){
		margin-top: 25px
	}
	.overview{
		font-size: 22px;
		line-height: 54px;
		color: #b2261e;
		font-weight:700;
		margin-top:20px;
	}
	.one-row{
		width: 90%;
		display: flex;
		justify-content: space-between;
		flex-direction: column
	}
	.pictures{
		display: flex;
		justify-content: space-between;
	}
	.pic-item img{
		display: block;
	}
	.item-desc{
		height:53px;
		letter-spacing: 10px;
		width: 100%;
		text-align: center;
		background: #f8f0f1;
		color:#333;
		font-size:15px;
		line-height: 53px
	}
	.usage{
		align-self: flex-end;
		margin: 20px 0;
		font-weight: 700
	}
	.procedure{
		max-width: 940px;
		margin:3% auto 0;
		display: flex;
		justify-content: space-between
	}
	.procedure-item{
		background: url('../assets/images/competition/time-bgc.png');
		background-size: 100% 100%;
		font-size:24px;
		text-align: center;
		display: flex;
		flex-direction: column;
		justify-content: center;
		padding:20px 35px;
		font-weight: 700;
		.step{
			margin-top:20px;
			color: rgb(178,38,30)
		}

	}

	.prize{
		margin:0 auto;
		position: relative;
		.pictures{
			margin:70px auto 0;
			max-width:940px;
			.pic-item{
				max-width:30%;
				&:nth-child(2){
					max-width:35%;
				}
			}

		}
		.best{
			margin-top:-20px;
		}
		.best	+	div{
				margin-top:23px;
			}
		.quantity{
			font-weight: 700;
			color:#333;
		}
		.prize-cat{
			position: absolute;
			top:-11%;
			left:0;
		}
	}
	.quantity{
		margin-top:45px
	}
	.criterion {
		position: relative;
		.pic-item{
			display: flex;
			flex-direction: column;
			align-items: center;
			float:left;
			width:25%;
			.quantity{
				width:100%;
				font-size:12px;
				font-weight: 400;
				color:#999;
				line-height: 18px;
				margin-top:10%;
			}
		}
		.criterion-cat{
			position: absolute;
			top: -25%;
    	right: 0.5%;
		}
	}
	.one-line{
		border-right: 1px solid rgb(153,153,153)
	}
	.explain{
		padding:43px 20px;
		color: #333;
		position: relative;
		margin-top: 0 !important;
		.explain-title{
			font-size: 24px;
			margin: 60px 0 20px;
			font-weight: 700
		}
		.explain-cat{
			position: absolute;
			top: -2%;
    	left: -5%;
		}
		p{
			padding-left:25px;
			li{
				line-height:30px;
				letter-spacing: 2px;
				
			}
		}
	}
	.contact{
		color:#080234;
		font-size: 20px;
	}
	.contactUs{
		margin-top:57px;
		display: flex;
		justify-content: space-around;
		align-items: center;
		.way{
			display: flex;
			flex-direction: column;
			align-items: center;
			font-size:18px;
			color:#333;
			width:49%;
			.ourwechat{
				margin-top:20px;
				letter-spacing: 2px;
			}
			.microblog{
				padding:20px;
				background: #fff;
				border:1px solid rgba(204, 204, 204, 0.4);
				display: flex;
				align-items: center;
				span{
					margin-left:20px
				}
			}
		}
		.oneline{
			width:1px;
			height:208px;
			background-color: #999;
		}
	}
	.download{
		margin-top:76px;
		display: inline-block;
		width:100%;
		text-align: center;
		font-size:24px;
		text-decoration:underline;
		font-weight: 700
	}
	.wrap-width{
		width: 66.5%;
		background-color: #fff;
		border: 4px solid #000;
		border-radius: 10px;
		box-sizing: border-box;
		padding: 5% 2%;
		margin:0 auto;
	}
	.footer-wrap{
		background: url("../assets/images/competition/footer-bgc.jpg") center bottom no-repeat;
		background-size: 100%;
		padding-bottom: 5%;
	}
	.arrow{
		display: flex;
		align-items: center
	}
</style>
